import React, { useState } from "react";
import Query from "components/Query";
import { Link, useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import Title from "components/Title";
import LazyLoadImage from "components/LazyLoadImage";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const PageCardD = React.memo(({ title, url }) => {

  const [buttonId, setButtonId] = useState();
  const history = useHistory();

  const handleMouseEnter = (id) => {
    setButtonId(id);
  };

  const handleMouseLeave = () => {
    setButtonId("");
  };
  return (
    <Query url={url}>
      {({ data }) => (
        <>
          <div className="about-us-wrapper">
            <img className="about-diamond wow bounceInLeft" src="/img/diamonds-top.svg" />
            <div className="about-flex">
              <div className="wow fadeInUp">
                <h3 className="about-us-title">About Us</h3>
                <h1 className="a-legacy">
                  A Legacy of Healthcare
                  <br /> Excellence
                </h1>
                <p className="about-paragraph-one">
                  Sabine Hospital and Research Centre is a progressive, hi-tech
                  hospital offering successful programmes in Infertility,
                  Assisted Reproductive Technology, Obstetrics, Gynaecology,
                  Neonatology, Paediatrics, General Surgery and Genetics.
                </p>
                <p className="about-paragraph-two">
                  The prime aim of our hospital is to provide utmost world class
                  care to the people. Founded in 2010 by Dr Sabine Sivadasan, we
                  position ourselves as the best infertility centre with the
                  highest success rate in IVF and ICSI. We are committed to
                  provide quality health care round the clock.
                </p>
                <button
                onClick={()=>history.push("/about-us")}
                  onMouseEnter={() => {
                    handleMouseEnter("aboutUs");
                  }}
                  onMouseLeave={handleMouseLeave}
                  className="about-us-button"
                >
                  <p>Read More</p>
                  <img src = {
                      buttonId == "aboutUs"
                        ? "/img/arrow-right-big.svg"
                        : "/img/arrow-right.svg"
                    } />
                </button>
              </div>
              <img className="about-us-image wow slideInRight" src="/img/about-us-image.jpg" />
            </div>
            {/* <div className="col-lg-3 col-md-4">
              <div className="about-img-wrapper wow fadeInUp">
                <div className="about-img" style={{ position: "relative" }}>
                  <LazyLoadImage
                    overlaySrc={data.mainImage.thumbnail}
                    src={`${process.env.REACT_APP_BASE_URL}/${data.mainImage.url}`}
                    className="img-fluid lazy"
                    alt={data.imageTag}
                  />
                </div>
              </div>
            </div> */}
            {/* <div className="col-lg-4 col-md-8">
              <div className="about-content-wrapper wow fadeInUp">
                <Title title={title} />
                <div className="about-content">
                  <div
                    className="ql-editor"
                    dangerouslySetInnerHTML={{
                      __html: `${data.content.slice(0, 200)}...`,
                    }}
                  />

                  <div className="btn-wrapper">
                    <Link to="/about-us" className="btn small-btn">
                      Read More <i className="fas fa-arrow-right" />
                    </Link>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </>
      )}
    </Query>
  );
});

PageCardD.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string,
};

PageCardD.defaultProps = {
  title: "",
};

export default PageCardD;
